import type { Moment } from "moment"
import moment from "moment"

/** Normalizes any Moment (with adapter time / offsets) to a local calendar date at midnight. */
export function toCalendarDay(d: Moment): Moment {
  if (!d?.isValid()) return moment.invalid()
  return moment(d.format("YYYY-MM-DD"), "YYYY-MM-DD")
}

/** True when the range uses sub-day clock times (e.g. last 30 minutes), not whole calendar days. */
export function rangeHasTimePrecision([start, end]: [Moment, Moment]): boolean {
  if (!start?.isValid() || !end?.isValid()) return false
  const isStartMidnight = start.isSame(start.clone().startOf("day"))
  const isEndMidnight = end.isSame(end.clone().startOf("day"))
  const isEndEndOfDay = end.isSame(end.clone().endOf("day"))
  // "Now" or any non-day-boundary end (last 30 min / 12 h)
  if (!isEndMidnight && !isEndEndOfDay) return true
  if (!isStartMidnight) return true
  return false
}
